import NextHead from "next/head";

import useUrl from "@/hooks/useUrl";

export type SEOProps = {
  title: string;
  description: string;
  image?: string;
  translations?: { language: string; path: string }[];
};

export const Head = ({ title, description, image, translations }: SEOProps) => {
  const { generateHreflangUrls, baseUrl, currentUrl } = useUrl();

  const img = image ?? `${baseUrl}/assets/ogImage.jpg`;

  const alternateLinks = translations
    ? translations.map(({ language, path }) => {
        return (
          <link
            key={language}
            rel="alternate"
            hrefLang={language}
            href={`${baseUrl}/${path}`}
          />
        );
      })
    : generateHreflangUrls().map(({ lang, url }) => (
        <link key={lang} rel="alternate" hrefLang={lang} href={url} />
      ));

  return (
    <NextHead>
      <base href={baseUrl} />

      {/* Base SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="shortcut icon" href="/favicon.ico" />
      <link rel="canonical" href={currentUrl} />
      {alternateLinks}

      {/* OpenGraph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="På(fyll)™" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="no-NO" />
      <meta property="og:locale:alternate" content="en-NO" />

      {/* X */}
      <meta name="twitter:title" content={title}></meta>
      <meta name="twitter:description" content={description}></meta>
      <meta name="twitter:image" content={img}></meta>
      <meta name="twitter:site" content="@pafyll"></meta>
    </NextHead>
  );
};
